/**
 * Löst die Backend-Basis-URL für axios auf.
 *
 * Regel: **gesetzt (auch leer) gewinnt; nur `undefined` fällt auf den Default**.
 * Unterscheidung per `typeof … === 'string'`, NICHT per Truthiness — ein leerer
 * String (`''`) ist eine bewusst gesetzte same-origin-Basis-URL und darf NICHT
 * auf den Localhost-Default durchfallen (Falsy-Falle bei `value || fallback`).
 *
 * Reihenfolge: zuerst `defined` (build-time `__VITE_BACKEND_URL__`), dann
 * `envValue` (`import.meta.env.VITE_BACKEND_URL`), zuletzt der Dev-Default.
 *
 * @param defined build-time definierter Wert (`__VITE_BACKEND_URL__`), oder `undefined`
 * @param envValue Vite-Env-Wert (`import.meta.env.VITE_BACKEND_URL`), oder `undefined`
 * @returns aufgelöste Backend-Basis-URL (leerer String = same-origin)
 */
export function resolveBackendUrl(
  defined: string | undefined,
  envValue: string | undefined,
): string {
  if (typeof defined === 'string') {
    return defined
  }
  if (typeof envValue === 'string') {
    return envValue
  }
  return 'http://localhost:7170'
}
